import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { useFormik, FormikErrors } from 'formik';
import UIKitButton from '../../../../shared/UIKITComponents/Button';
import UIKitDatepicker from '../../../../shared/UIKITComponents/DatepickerCustom';
import { MilestonesRowProps } from './MilestonesRowProps';
import Context from '../context/DetailsContext';
import { GrievanceMilestone } from '../../../../services/types/Grievance';

const GenericMilestonesRow = (props: MilestonesRowProps) => {
  const { isEditable, phase, onPhaseApply, validate } = props;
  const { grievancePhaseData, grievanceNumber } = useContext(Context);
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: { ...phase },
    validate,
    enableReinitialize: true,
    onSubmit: (values) => {
      onPhaseApply(values, grievancePhaseData);
    },
  });

  useEffect(() => () => formik.resetForm(), [grievanceNumber]);

  return (
    <form className="grv-phases-form" onSubmit={formik.handleSubmit}>
      <Grid
        container
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'flex-start',
        }}
      >
        {phase.milestones.map((milestone, i) => {
          const hasError =
            formik.errors &&
            formik.errors.milestones &&
            formik.errors.milestones[i] &&
            typeof formik.errors.milestones[i] === 'object' &&
            typeof formik.errors.milestones[i].date === 'string';

          return (
            <Grid key={`milestone${i.toString()}`} size={4}>
              <UIKitDatepicker
                name={`milestones[${i}].date`}
                // htmlId (no name, que es el path del campo de Formik) escopa el
                // id/aria-labelledby real del DOM por fase - sin esto, dos filas de
                // fase distintas expandidas a la vez (cada una con su propio formik,
                // pero el mismo "milestones[i].date" posicional) terminan con el
                // mismo id de input, rompiendo aria-labelledby en la que se renderiza
                // después (bug real de accesibilidad, Fase 5/F7-EXIT).
                htmlId={`milestones[${phase.phaseId}][${i}].date`}
                label={milestone.name}
                selectedDate={
                  formik.values.milestones[i].date
                    ? new Date(formik.values.milestones[i].date)
                    : null
                }
                onChange={(date) => formik.setFieldValue(`milestones[${i}].date`, date)}
                onBlur={formik.handleBlur}
                readonly={!isEditable}
                error={!!hasError}
                helperText={
                  hasError
                    ? (formik.errors.milestones![i] as FormikErrors<GrievanceMilestone>).date
                    : null
                }
              />
            </Grid>
          );
        })}
        {isEditable && (
          <Grid className="grv-milestone-submit-btn">
            <UIKitButton
              text={t('apply')}
              type="submit"
              className="btn-primary"
              disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
            />
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default GenericMilestonesRow;
